<script lang="ts" setup>
import { SectionHeader, SectionHeaderDescription, SectionHeaderTitle } from '@forgd/ui-kit/section-header'
import { Tabs, TabsIndicator, TabsList, TabsTriggerLink } from '@forgd/ui-kit/tabs'

const tabs = [
  { label: 'Reports History', to: '/reports-history' },
  { label: 'API Keys', to: '/api-keys' },
]

const route = useRoute()
</script>

<template>
  <div data-layout="home">
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard">
      <div class="flex flex-col gap-10">
        <SectionHeader>
          <SectionHeaderTitle>Manage the details of your data and API keys</SectionHeaderTitle>
          <SectionHeaderDescription class="xl:w-1/2">
            Find the historical records of your submitted reports, and the status of the data, or create API keys to automate your reports.
          </SectionHeaderDescription>
        </SectionHeader>
        <Tabs :model-value="route.path">
          <TabsList>
            <TabsTriggerLink v-for="tab in tabs" :key="tab.to" :to="tab.to">
              {{ tab.label }}
            </TabsTriggerLink>
            <TabsIndicator />
          </TabsList>
        </Tabs>
        <div>
          <slot />
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>
